import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import React from "react";
import {useAppState, useRootStore, useUserState} from "@stores/AppStateContext";

import {ContextMenu} from '../../../components/ContextMenu';
import {MarkAsReadIcon} from "../../../components/icons/MarkAsReadIcon";
import {NotificationCircleIcon} from "../../../components/icons/NotificationCircleIcon";
import {DeleteIcon} from "../../../components/icons/DeleteIcon";
import {resendNotifications} from "../../../../actions/notification/resend";

import {MODALS} from "../../../screens/modals/modal-names";
import {PAGES} from "@stores/ViewStore";
import {ItemModelType} from "@stores/WorkspaceStore";
import {useCrudServices} from "../../../../platform/hooks/useServiceCombinations";

export interface AcknowledgmentContextMenuProps {
    handleClose: () => void,
    isDark: boolean
}

export const AcknowledgmentContextMenu = observer(({handleClose, isDark}: AcknowledgmentContextMenuProps) => {
    const appState = useAppState();
    const rootStore = useRootStore();
    const userState = useUserState();
    const selectedNode = rootStore.view.workspace!.selected;
    const crudServices = useCrudServices();
    return (
        <ContextMenu
            isDark={isDark}
            handleClose={handleClose}
            items={!selectedNode!.acknowledgementRequired ? [
                {
                    text: intl.get('acknowledgment.context-menu.acknowledgments_overview').d('Acknowledgments Overview'),
                    Icon: MarkAsReadIcon,
                    onClick: () => {
                        rootStore.view.openPageByName(
                            PAGES.ACKNOWLEDGMENTS_OVERVIEW,
                            {},
                            undefined,
                            {
                                back: () => {
                                    rootStore.view.openPageByName(PAGES.DOC_EDIT, {id: selectedNode!.id});
                                }
                            });
                        appState.setContextMenu(null)
                    },
                },
            ] : [
                {
                    text: intl.get('acknowledgment.context-menu.send.reminder').d('Send Reminder to All'),
                    Icon: NotificationCircleIcon,
                    onClick: () => {
                        resendNotifications(crudServices, userState!, selectedNode)
                        appState.setContextMenu(null)
                    },
                },
                {
                    text: intl.get('acknowledgment.context-menu.reset.confirmation').d('Reset Confirmations'),
                    Icon: DeleteIcon,
                    onClick: () => {
                        appState.setModal({name: MODALS.REMOVE_ACKNOWLEDGMENT_REQUIRE, params: {itemMST: selectedNode as ItemModelType}})
                        appState.setContextMenu(null)
                    },
                },
                {
                    text: intl.get('acknowledgment.context-menu.acknowledgments_overview').d('Acknowledgments Overview'),
                    Icon: MarkAsReadIcon,
                    onClick: () => {
                        rootStore.view.openPageByName('acknowledgments_overview')
                        appState.setContextMenu(null)
                    },
                },

            ]}
        />
    )
})
